import {Injectable} from "@angular/core";
import {ApiUrl} from "../shared/models/apiurl.models";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {AdminWebsocketService} from "./admin-websocket.service";
import {BehaviorSubject, Observable} from "rxjs";
import {SystemApp} from "../constans/SystemConfigurations";
interface OnlineUser {
    id: number;
    username: string;
    email: string;
}
@Injectable()
export class AdminService {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken()
        })
    }
    private onlineUsers$ = new BehaviorSubject<Map<number, OnlineUser>>(new Map());
    constructor(private apiUrl: ApiUrl,public http:HttpClient, public snackBar: MatSnackBar, public router:Router, public adminWebsocketService:AdminWebsocketService) {
        this.adminWebsocketService.connect();

        this.adminWebsocketService.getNotifications().subscribe(res=>{
            if(res["type"]=="online_users") {
                this.initializeOnlineUsers();
            }
        })
    }
    getOnlineUsers(): Observable<Map<number, OnlineUser>> {
        return this.onlineUsers$.asObservable();
    }

    initializeOnlineUsers(): void {
        this.http.get<{ data: OnlineUser[] }>(this.apiUrl.getOnlineUsersUrl(),this.options)
            .subscribe({
                next: (response) => {
                    const usersMap = new Map<number, OnlineUser>(
                        response.data.map(user => [user.id, user])
                    );
                    this.onlineUsers$.next(usersMap);
                },
                error: (err) => console.error('Failed to fetch online users:', err)
            });
    }


    signOut() {

        localStorage.removeItem("token");
        localStorage.removeItem("is_superuser");
        localStorage.removeItem("token")
        localStorage.removeItem("is_superuser");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("email");
        localStorage.removeItem("avatar");
        localStorage.removeItem("userDetails");
        this.router.navigate(['/sign-in'], ).then(()=>{
            window.location.reload();
        });
    }
}
